<nav class="navbar navbar-expand-lg fixed-top" aria-label="navbar">
    <div class="container">
        <a routerLink="/" class="d-flex align-items-center mb-2 mb-lg-0 link-body-emphasis text-decoration-none">
            <img src="/images/logo/Referio.png" alt="Logo" width="80" class="me-4" />
        </a>
        <button
            class="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbar"
            aria-controls="navbar"
            aria-expanded="false"
            aria-label="Toggle navigation"
        >
            <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbar">
            <button class="mobile-close" type="button" data-bs-toggle="collapse" data-bs-target="#navbar">
                ✕
            </button>

            <ul class="navbar-nav me-auto mb-2 mb-lg-0" style="flex-direction: row; justify-content: space-around;">
                <li class="nav-item">
                    <a class="nav-link text-white" aria-current="page" routerLink="/" data-bs-toggle="collapse" data-bs-target="#navbar">Accueil</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link text-white" aria-current="page" routerLink="/favorites" data-bs-toggle="collapse" data-bs-target="#navbar">Favoris</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link text-white" aria-current="page" routerLink="/map" data-bs-toggle="collapse" data-bs-target="#navbar">Carte</a>
                </li>
                @if(user && (user.userType === 'admin' || user.userType === 'pro')){
                    <li class="nav-item">
                        <a class="nav-link text-white" aria-current="page" routerLink="/dashboard" data-bs-toggle="collapse" data-bs-target="#navbar">Tableau de bord</a>
                    </li>
                }
                @if(user && user.userType === 'admin'){
                    <li class="nav-item">
                        <a class="nav-link text-white" aria-current="page" routerLink="/admin" data-bs-toggle="collapse" data-bs-target="#navbar">Admin</a>
                    </li>
                }
            </ul>
            <div class="col-12 col-lg-auto mb-3 mb-lg-0 me-lg-3" role="search">
                <div class="input-group">
                    <input id="searchInput" type="search" class="form-control" placeholder="Rechercher..." aria-label="Recherche" [(ngModel)]="searchTerm"  (keydown.enter)="onSearch()"/>
                    <button class="btn btn-outline-secondary text-white" type="button" (click)="onSearch()">➤</button>
                </div>
            </div>
            <div class="dropdown text-center">
                <a 
                    href="#" 
                    class="d-block link-body-emphasis text-decoration-none dropdown-toggle"
                    (click)="toggleDropdown($event)"
                    data-bs-toggle="dropdown" 
                    aria-expanded="false"
                >
                    @if(user && user.avatar){
                        <img [src]="apiUrl + user.avatar" alt="avatar" id="avatar" width="50" height="50" class="rounded-circle" />
                    } @else {
                        <img src="/images/user/avatar.png" alt="avatar" id="avatar" width="50" height="50" class="rounded-circle" />
                    }
                </a>
                <ul class="dropdown-menu text-small show" [class.show]="isOpen">
                    @if(user){
                        <li><a class="dropdown-item" routerLink="/profile" data-bs-toggle="collapse" data-bs-target="#navbar">Profil</a></li>
                        <li>
                            <hr class="dropdown-divider" />
                        </li>
                        <li><button class="dropdown-item" (click)="logout()" data-bs-toggle="collapse" data-bs-target="#navbar">Se déconnecter</button></li>
                    } @else {
                        <li><a class="dropdown-item" routerLink="/signin" data-bs-toggle="collapse" data-bs-target="#navbar">Se connecter</a></li>
                        <li><a class="dropdown-item" routerLink="/signup" data-bs-toggle="collapse" data-bs-target="#navbar">S'inscrire</a></li>
                    }
                </ul>
            </div>
        </div>
    </div>
</nav>